import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { RootState } from '../..';
interface IDirectorAdditionalInfoRequest {
  businessId: string;
  directorId: string;
  identityVerificationUrl?: string;
  proofOfAddressUrl?: string;
}

interface IDirectorAdditionalInfoResponse {
  success?: boolean;
  message?: string;
  errors?: IApiResponseError[];
}

const initialState: IApiState<IDirectorAdditionalInfoResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const submitDirectorAdditionalInfoAsync = createAsyncThunk(
  'directorAdditionalInfo/submit',
  async (
    values: IDirectorAdditionalInfoRequest,
    { rejectWithValue, getState }
  ) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;
      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
        },
      };

      const { data } = await api.patch<IDirectorAdditionalInfoResponse>(
        '/request-info',
        values,
        config
      );

      return data;
    } catch (err) {
      const error = err as AxiosError<IDirectorAdditionalInfoResponse>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const directorAdditionalInfoSlice = createSlice({
  name: 'directorAdditionalInfo/submit',
  initialState,
  reducers: {
    resetSubmitDirectorAdditionalInfo(state) {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitDirectorAdditionalInfoAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(submitDirectorAdditionalInfoAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload;
      })
      .addCase(submitDirectorAdditionalInfoAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IDirectorAdditionalInfoResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetSubmitDirectorAdditionalInfo } =
  directorAdditionalInfoSlice.actions;

export default directorAdditionalInfoSlice.reducer;
